import React, { useMemo } from 'react';

import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { logOut } from '../../data/store/user/userActions';

import { Button, Modal, Row } from 'antd';

import './style.scss';

const ModalTimerLogout = ({ open, closeModal, resetTimer, remainingTime }) => {
  const { t } = useTranslation('');
  const dispatch = useDispatch();

  const timer = useMemo(() => {
    const totalSeconds = Math.ceil(remainingTime / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
  }, [remainingTime]);

  const handleStayLoggedIn = () => {
    resetTimer();
    closeModal();
  };

  const handleLogout = () => {
    dispatch(logOut());
  };

  return (
    <Modal
      width={700}
      closable={false}
      className="timer-logout-modal"
      centered
      open={open}
      footer={false}
      zIndex={1500}
    >
      <p className="modal-title">
        {t('TIMER_LOGOUT_TITLE')}
        <span className="timer">{timer}</span>
      </p>
      <p className="modal-description">{t('TIMER_LOGOUT_DESCRIPTION')}</p>
      <Row className="modal-newportfolio-button-wrapper">
        <Button
          type="text"
          className="modal-action-btn cancel-btn"
          onClick={handleLogout}
        >
          {t('LOG_OUT')}
        </Button>
        <Button
          type="default"
          className="modal-action-btn save-btn"
          onClick={handleStayLoggedIn}
        >
          {t('STAY_LOGGED_IN')}
        </Button>
      </Row>
    </Modal>
  );
};

export default ModalTimerLogout;

ModalTimerLogout.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  resetTimer: PropTypes.func,
  remainingTime: PropTypes.number,
};
